import { driver } from 'driver.js';
import '../main.css';
import 'driver.js/dist/driver.css';

export const createModuleDriverObj = (dispatch, navigate) => {
  const driverObj = driver({
    showProgress: true,
    nextBtnText: 'Next',
    prevBtnText: 'Previous',
    doneBtnText: 'Done',
    popoverClass: 'driverjs-theme',
    steps: [
      {
        element: '.moduleName',
        popover: {
          title: 'Enter Module Name',
          description:
            'Use this field to specify the name of the new module. Ensure the name is descriptive and unique.',
          side: 'left',
          align: 'start',
        },
      },
      {
        element: '.moduleDescription',
        popover: {
          title: 'Add Module Description',
          description:
            'Provide a detailed description of the module. This helps to understand the module’s purpose and functionality.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.moduleType',
        popover: {
          title: 'Select Module Type',
          description:
            'Choose the type of the module from the available options. This will determine the module’s behavior and settings.',
          side: 'top',
          align: 'end',
        },
      },

      {
        element: '.createModule',
        popover: {
          title: 'Create Module',
          description:
            'Click this button to finalize and create the module. Ensure all details are correctly filled before confirming the creation.',
          side: 'top',
          align: 'end',
        },
      },
      {
        element: '.cancelModuleCreation',
        popover: {
          title: 'Cancel Module Creation',
          description:
            'Click here to cancel the module creation process. Any unsaved changes will be lost, and the module will not be created.',
          side: 'top',
          align: 'end',
        },
      },
    ],
  });
  return driverObj;
};
export default createModuleDriverObj;
